import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: Date | string | number, locale: string = 'en-US'): string {
    const currentYear = new Date().getFullYear();
    const date = new Date(value);
    const year = date.getFullYear();
    // If the year is the current year, format without year
    if (year === currentYear) {
      return formatDate(value, 'MMM d', locale); // Format without year
    } else {
      return formatDate(value, 'mediumDate', locale); // Use mediumDate for other years
    }
  }

}
